var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.66667C1 2.19391 2.19395 1 3.66677 1C5.13958 1 6.33354 2.19391 6.33354 3.66667C6.33354 5.13943 5.13958 6.33333 3.66677 6.33333C2.19395 6.33333 1 5.13943 1 3.66667Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.3333C1 12.8606 2.19395 11.6667 3.66677 11.6667C5.13958 11.6667 6.33354 12.8606 6.33354 14.3333C6.33354 15.8061 5.13958 17 3.66677 17C2.19395 17 1 15.8061 1 14.3333Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6671 12C11.6671 11.8159 11.8163 11.6667 12.0004 11.6667H27.3343C27.5184 11.6667 27.6677 11.8159 27.6677 12V16.6667C27.6677 16.8508 27.5184 17 27.3343 17H12.0004C11.8163 17 11.6671 16.8508 11.6671 16.6667V12Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6671 1.33333C11.6671 1.14924 11.8163 1 12.0004 1H27.3343C27.5184 1 27.6677 1.14924 27.6677 1.33333V6C27.6677 6.1841 27.5184 6.33333 27.3343 6.33333H12.0004C11.8163 6.33333 11.6671 6.1841 11.6671 6V1.33333Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6671 22.6667C11.6671 22.4826 11.8163 22.3333 12.0004 22.3333H27.3343C27.5184 22.3333 27.6677 22.4826 27.6677 22.6667V27.3333C27.6677 27.5174 27.5184 27.6667 27.3343 27.6667H12.0004C11.8163 27.6667 11.6671 27.5174 11.6671 27.3333V22.6667Z",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 23.5272 2.19395 22.3333 3.66677 22.3333C5.13958 22.3333 6.33354 23.5272 6.33354 25C6.33354 26.4728 5.13958 27.6667 3.66677 27.6667C2.19395 27.6667 1 26.4728 1 25Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d480e7f2000a56276be9a1f89348b815.svg";
export { ForwardRef as ReactComponent };